module.exports = __webpack_public_path__ + "static/img/vr2.e1ff8e0b.png";